import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import styles from './style.module.scss';


interface QuizOverlayProps {
  quizData: {
    question: string;
    options: string[];
    correctAnswer: number;
  };
  onComplete: (correct: boolean, selectedIndex: number) => void;
}

const QuizOverlay: React.FC<QuizOverlayProps> = ({ quizData, onComplete }) => {
  const { t } = useTranslation();
  const [selectedAnswer, setSelectedAnswer] = useState<number | null>(null);
  const [showResult, setShowResult] = useState(false);

  const handleAnswer = (index: number) => {
    if (showResult) return;
    
    setSelectedAnswer(index);
    setShowResult(true);
    
    const isCorrect = index === quizData.correctAnswer;
    
    setTimeout(() => {
      onComplete(isCorrect, index);
    }, 2000);
  };

  return (
    <div className={styles.overlayContent}>
      <h3 className={styles.overlayTitle}>
        {t('games.snake.quiz_time')}
      </h3>
      
      <p className={styles.overlayQuestion} dir="auto">
        {quizData.question}
      </p>

      <div className={styles.answersWrapper}>
        {quizData.options.map((option, index) => {
          let buttonClass = styles.answerButton;
          
          if (showResult) {
            buttonClass = `${buttonClass} ${styles.answerButtonDisabled}`;
            if (index === quizData.correctAnswer) {
              buttonClass = `${buttonClass} ${styles.answerButtonCorrect}`;
            } else if (index === selectedAnswer) {
              buttonClass = `${buttonClass} ${styles.answerButtonIncorrect}`;
            }
          }

          return (
            <button
              key={index}
              onClick={() => handleAnswer(index)}
              disabled={showResult}
              className={buttonClass}
              dir="auto"
            >
              {String.fromCharCode(65 + index)}. {option}
            </button>
          );
        })}
      </div>

      {showResult && (
        <p className={`${styles.resultMessage} ${
          selectedAnswer === quizData.correctAnswer 
            ? styles.resultCorrect 
            : styles.resultIncorrect
        }`}>
          {selectedAnswer === quizData.correctAnswer 
            ? t('games.snake.correct_answer') 
            : t('games.snake.incorrect_answer')}
        </p>
      )}
    </div>
  );
};

export default QuizOverlay;

